import { Component, OnInit } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { IOAuthService } from 'src/app/_Services/user/iOAuthService';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent implements OnInit {

  title: string;
  message: string;
  public _image: string;

  constructor(private oAuthService: IOAuthService, private translate: TranslateService) {
     this._image = "assets/images/went-wrong.svg";
  }

  ngOnInit() {
    this.translate.get('INTERCEPTOR.LBL_UNAUTHORIZED_HEADER').subscribe((res: string) => {
      this.title = res;
    });
    this.translate.get('INTERCEPTOR.LBL_UNAUTHORIZED_MESSAGE').subscribe((res: string) => {
      this.message = res;
    });
  }

  async logout(){
    await this.oAuthService.logOut();
  }
}
